{
  "columns": [
    {
      "header_id": "consumerPplId",
      "header_label": "Participant PPL ID",
      "jsonpath": "consumerPplId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "mco",
      "header_label": "MCO",
      "jsonpath": "mco",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "cin",
      "header_label": "CIN",
      "jsonpath": "cin",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "batchId",
      "header_label": "Batch Id",
      "jsonpath": "batchId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "fileName",
      "header_label": "File Name",
      "jsonpath": "fileName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "payerName",
      "header_label": "Payer Name",
      "jsonpath": "payerName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "serviceDate",
      "header_label": "Service Date",
      "jsonpath": "serviceDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "pmpm",
      "header_label": "PMPM",
      "jsonpath": "pmpm",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    }
  ],
  "buttons": [],
  "apiDetails": "claims.json",
  "pageName": "claimsList",
  "orderByColumn": ["tracking_number"],
  "orderBy": ["desc"]
}
